import Filters from './Filters.vue';

export default Filters;